/** Known application IDs of different booking apps (branded websites, apps etc.) */
export enum WellKnownApplicationID {
    OneThreeCabs = 94,

    Cabcharge = 100,

    SilverService = 101
}